import React, { useRef } from 'react';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import PopupNew from 'apps/auth/components/common/Popup/PopupNew';
import { AUTH_GA_ACCOUNTS, AUTH_PROFILE_FIELDS } from 'apps/auth/constants/UrlConstants';

import ConfirmEmailPopup from '../../email/ConfirmEmailPopup';

const EmailModal = (props) => {
    const popupRef = useRef(null);
    let navBarProps = {};
    if (props.secondButton) {
        navBarProps = {
            topButtonType: 'link',
            topButtonCaption: props.secondButton,
            topButtonLink: AUTH_GA_ACCOUNTS,
        };
    }

    return (
        <>
            <InfoPage
                {...navBarProps}
                iconName={props.icon}
                iconColor="primary"
                headerText={<DangerouslyHtml dangerouslyHtml={props.title} />}
                secondaryText={<DangerouslyHtml dangerouslyHtml={props.text} />}
                primaryButtonCaption={props.firstButton}
                primaryButtonType="link"
                primaryButtonLink={AUTH_PROFILE_FIELDS}
                primaryButtonOnClick={(e) => {
                    if (props.showPopup) {
                        e.preventDefault();
                        popupRef.current?.open(<ConfirmEmailPopup popupRef={popupRef} />);
                    } else if (props.setModal) {
                        e.preventDefault();
                        props.setModal('second');
                    }
                }}
            />
            <PopupNew ref={popupRef} />
        </>
    );
};

export default EmailModal;
